import * as actions from './Actions';

const parseUser = (payload) => {
  if (!payload) return undefined;
  return {
    id: Number(payload.id ?? payload.userId ?? 0),
    username: payload.username || payload.name || '',
    email: payload.email || '',
  };
};

const parseQuizLite = (payload) => {
  if (!payload) return undefined;
  return {
    quizId: Number(payload.quizId ?? payload.id ?? 0),
    posteId: Number(payload.posteId ?? payload.poste?.posteId ?? payload.poste?.id ?? 0) || undefined,
    title: payload.title || '',
    description: payload.description || '',
    timeLimit: Number(payload.timeLimit ?? 0),
    maxAttempts: Number(payload.maxAttempts ?? 1),
    shuffleQuestions: Boolean(payload.shuffleQuestions ?? false),
    shuffleOptions: Boolean(payload.shuffleOptions ?? false),
    isActive: Boolean(payload.isActive ?? true),
    createdAt: payload.createdAt || null,
    updatedAt: payload.updatedAt || null,
  };
};

const parseAttempt = (payload) => {
  if (!payload) return null;
  const user = parseUser(payload.user);
  const quiz = parseQuizLite(payload.quiz);
  return {
    attemptId: Number(payload.attemptId ?? payload.id ?? 0),
    userId: Number(payload.userId ?? user?.id ?? 0),
    quizId: Number(payload.quizId ?? quiz?.quizId ?? 0),
    startTime: payload.startTime || null,
    endTime: payload.endTime || null,
    timeSpent: Number(payload.timeSpent ?? 0),
    score: Number(payload.score ?? 0),
    status: String(payload.status || '').toLowerCase(),
    createdAt: payload.createdAt || null,
    updatedAt: payload.updatedAt || null,
    user,
    quiz,
  };
};

export const quizAttemptsReducer = (state = [], action) => {
  switch (action.type) {
    case actions.INITIALIZE_QUIZ_ATTEMPTS: {
      const list = Array.isArray(action.payload) ? action.payload : [];
      return list.map(parseAttempt).filter(Boolean);
    }
    case actions.ADD_QUIZ_ATTEMPT:
      return [...state, parseAttempt(action.payload)].filter(Boolean);
    case actions.UPDATE_QUIZ_ATTEMPT:
      return state.map(a => (a.attemptId === (action.payload?.attemptId ?? action.payload?.id) ? parseAttempt(action.payload) : a));
    case actions.DELETE_QUIZ_ATTEMPT: {
      const id = Number(action.attemptId ?? action.id);
      return state.filter(a => a.attemptId !== id);
    }
    case actions.CLEAR_QUIZ_ATTEMPTS:
      return [];
    default:
      return state;
  }
};

export default quizAttemptsReducer;
